var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreHelpCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#84BDF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.76 29.58L38.36 25.18C37.8 24.62 37.64 23.84 37.86 23.14C38.6 20.9 39 18.5 39 16C39 14.9 39.9 14 41 14H48C49.1 14 50 14.9 50 16C50 34.78 34.78 50 16 50C14.9 50 14 49.1 14 48V41.02C14 39.92 14.9 39.02 16 39.02C18.48 39.02 20.9 38.62 23.14 37.88C23.84 37.64 24.64 37.82 25.18 38.36L29.58 42.76C35.24 39.86 39.88 35.24 42.76 29.58Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreHelpCall);
export default __webpack_public_path__ + "static/media/MoreHelpCall.82c59654c400f4c9c4ff7f34245e9c50.svg";
export { ForwardRef as ReactComponent };